import React, { useEffect, useState } from "react";
import { FMDPStorage } from "../shared/helper";

export const LoggedOut = () => {
  const [currentClientName, setCurrentClientName] = useState(FMDPStorage.get("selected-client"));

  useEffect(() => {
    if (currentClientName) {
      FMDPStorage.clear();
      FMDPStorage.set("selected-client", currentClientName);
    }
  }, [currentClientName]);

  return (
    <main className="logout-layout">
      <header className="qi-header">
        <h3 className="qi-header_title text-center">
          <strong>Fleet Mobility Data Platform</strong>
        </h3>
      </header>
      <div className="logout-form-container">
        <div>
          <h1 className="page-title">
            Your session in <strong>{currentClientName}</strong> has ended.
          </h1>
          <hr width="100%"></hr>
        </div>

        <p className="logout-form-container_error text-red-500 text-sm mb-4">
          You've been logged out of this portal because of the security reasons.
        </p>
      </div>

      <footer className="qi-footer text-center">
        <p className="">
          Copyright &copy;
          {new Date().getFullYear()} Fleet Management. All rights reserved.
        </p>
      </footer>
    </main>
  );
};
